import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Box,
    Typography,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { SequenceFlow, Task } from "model/activitiesModel";

interface SequenceFlowDialogProps {
    open: boolean;
    sequenceFlows: SequenceFlow[];
    onClose: () => void;
    onSelect: (sequenceFlow: SequenceFlow) => void;
    gatewayQuestion?: string | null;
}

const SequenceFlowDialog: React.FC<SequenceFlowDialogProps> = ({
    open,
    sequenceFlows,
    onClose,
    onSelect,
    gatewayQuestion
}) => {

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                },
            }}
        >
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="h6">
                        {gatewayQuestion}
                    </Typography>
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <List sx={{ pt: 0 }}>
                    {sequenceFlows.map((sequence) => (
                        <ListItem key={sequence.id} disablePadding>
                            <ListItemButton
                                onClick={() => onSelect(sequence)}
                                sx={{
                                    borderRadius: 1,
                                    mb: 1,
                                    border: "1px solid",
                                    borderColor: "divider",
                                    "&:hover": {
                                        backgroundColor: "action.hover",
                                        borderColor: "primary.main",
                                    },
                                }}
                            >
                                <ListItemText
                                    primary={sequence.name}
                                    primaryTypographyProps={{
                                        variant: "body1",
                                        fontWeight: 500,
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
        </Dialog>
    );
};

export default SequenceFlowDialog;